export const AD_SETTINGS_FORM_NAME = "ad-settings-modal";
